import { render, staticRenderFns } from "./FilingInfoTab.vue?vue&type=template&id=6cc7ff2a&"
import script from "./FilingInfoTab.vue?vue&type=script&lang=js&"
export * from "./FilingInfoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports